<template>
  <a class="tooltip-outer flex justify-center items-center mr-1 cursor-pointer">
    <div class="relative" v-if="isLoadingTTS">
      <img src="@/assets/image/ai/btn_AItalk_play_loading_circle.png">
      <img src="@/assets/image/ai/loading_circle.png" class="absolute loading_circle">
    </div>
    <img src="@/assets/image/ai/btn_AItalk_play.png" v-if="!isPlayingAudio && !isLoadingTTS" @click="togglePlayBtn()">
    <img src="@/assets/image/ai/btn_AItalk_darkblue.png" v-if="ttsUrl && isPlayingAudio && !isLoadingTTS" @click="audio_stop()">
    <span class="tooltiptext">{{ $t('hover.play') }}</span>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
import Bus from '@/components//bus.js'
import allJs from '@/components/all.js'
export default {
  name: 'ChatPractice',
  props: {
    itemIdx: {
      type: Number,
      require: true
    },
    text: {
      type: String
    },
    isDisabledInput: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mediaRecorder: null,
      audioData: [],

      sound_effect: null,
      isPlayingAudio: false,

      ttsUrl: null,
      isLoadingTTS: false
    }
  },
  mixins: [
    allJs
  ],
  computed: {
    ...mapGetters([
      'playbackRate'
    ])
  },
  watch: {
    'playbackRate': {
      handler (newVal, oldVal) {
        let self = this
        if (newVal !== oldVal) {
          self.audio_setRate()
        }
      },
      immediate: true
    }
  },
  async mounted () {
    if (this.text && this.$route.name !== 'viewChat' && !this.ttsUrl) {
      this.ttsUrl = await this.getTTSUrl('female', this.text)
      this.sound_effect = new Audio(this.ttsUrl)
    }
    !this.isDisabledInput ? this.audio_play() : null

    Bus.$on('stopPlay', () => {
      this.isPlayingAudio ? this.audio_stop() : null
    })
  },
  beforeDestroy () {
    if (this.sound_effect) {
      this.audio_stop()
    }
  },
  methods: {
    async togglePlayBtn () {
      let self = this
      if (self.$route.name === 'viewChat') {
        if (self.text && !self.ttsUrl) {
          self.isLoadingTTS = true
          self.ttsUrl = await self.getTTSUrl('female', self.text)

          if (self.ttsUrl) {
            self.sound_effect = new Audio(self.ttsUrl)
            self.isLoadingTTS = false
            self.isPlayingAudio = true
            self.audio_play()
          }
        } else if (self.text && self.ttsUrl) {
          self.audio_play()
        }
      } else {
        self.audio_play()
      }
    },
    audio_play () {
      let self = this
      self.isPlayingAudio = true
      self.sound_effect.play()
      self.audio_setRate()
      self.sound_effect.addEventListener('ended', () => {
        self.audio_stop()
      })

      const randomBinary = Math.random() < 0.5 ? 1 : 2;
      self.$emit('emitTalkIdolIdx', randomBinary)
    },
    audio_stop () {
      let self = this
      self.isPlayingAudio = false
      self.sound_effect.pause()
      self.sound_effect.currentTime = 0

      self.$emit('emitTalkIdolIdx', 0)
    },
    audio_setRate () {
      let self = this
      self.sound_effect ? self.sound_effect.playbackRate = self.playbackRate : null
    }
  }
}
</script>
<style lang="scss" scoped>
  .loading_circle {
    top: 15%;
    left: 15%;
    transform: translate(-50%, -50%);
    animation: spin 2s infinite linear;
    transform-origin: center;
  }
  @keyframes spin  {
    from {
      transform: rotate(0deg);
      transform-origin: center;
    }
    to {
      transform: rotate(360deg);
      transform-origin: center;
    }
  }
</style>
